import { createBuilderModule } from '../../register-builder/builder-module';
import { iconNames } from '../../global/types';
import { BlockGridItem } from './BlockGridItem';

export default createBuilderModule(BlockGridItem, {
  name: 'BlockGridItem',
  image: 'https://cdn.zappy.app/213f0a68702998508b364f372a5f2f5f.png',
  inputs: [
    // Icon
    {
      name: 'iconName',
      type: 'string',
      enum: ['', ...Object.keys(iconNames)],
    },

    // Media
    {
      name: 'imageUrl',
      type: 'cloudinaryImage',
    },
    {
      name: 'imageAltText',
      type: 'string',
    },
    {
      name: 'wistiaId',
      type: 'string',
    },

    // Heading
    {
      name: 'heading',
      type: 'string',
      required: true,
      defaultValue: 'Example heading',
    },

    // Description
    {
      name: 'description',
      type: 'richText',
      required: true,
      defaultValue: '<p>Example content...</p>',
    },

    // Small text
    {
      name: 'smallText',
      type: 'string',
    },

    // Primary CTA
    {
      name: 'ctaText',
      type: 'string',
    },
    {
      name: 'ctaHref',
      type: 'string',
    },

    // Secondary CTA
    {
      name: 'secondaryCtaText',
      type: 'string',
    },
    {
      name: 'secondaryCtaHref',
      type: 'string',
    },

    // Toggles
    {
      name: 'isLink',
      friendlyName: 'Make entire block clickable',
      type: 'boolean',
      defaultValue: false,
    },
    {
      name: 'isCentered',
      friendlyName: 'Center align content',
      type: 'boolean',
      defaultValue: false,
    },
  ],
});
